import styled from "styled-components";
import { Link } from "react-router-dom";
import { RefObject } from "react";

const Logo = styled(Link)`
  font-family: "Tanker", sans-serif;
  font-size: 1.5rem;
  font-weight: normal;
  color: #373737;
  text-decoration: none;

  &:hover {
    color: #000;
    transition: all 0.2s;
  }
`;

interface FooterProps {
  aboutRef: RefObject<HTMLDivElement>;
  servicesRef: RefObject<HTMLDivElement>;
  achievementsRef: RefObject<HTMLDivElement>;
  packagesRef: RefObject<HTMLDivElement>;
  caseStudiesRef: RefObject<HTMLDivElement>;
  contactRef: RefObject<HTMLDivElement>;
}

export default function Footer({
  aboutRef,
  servicesRef,
  achievementsRef,
  packagesRef,
  caseStudiesRef,
  contactRef,
}: FooterProps) {
  const navLinks = [
    {
      label: "About",
      ref: aboutRef,
    },
    {
      label: "Services",
      ref: servicesRef,
    },
    {
      label: "Achievements",
      ref: achievementsRef,
    },
    {
      label: "Packages",
      ref: packagesRef,
    },
    {
      label: "Case Studies",
      ref: caseStudiesRef,
    },
    {
      label: "Contact",
      ref: contactRef,
    },
  ];

  const scrollToSection = (ref: RefObject<HTMLDivElement>) => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="container relative py-16 md:py-12 flex lg:flex-row flex-col">
      <div className="flex-col items-start gap-6 flex w-full">
        <p
          className="text-center w-full underline whitespace-nowrap overflow-hidden text-[clamp(0.8em,6vw,1em)]
        sm:text-[clamp(0.8em,6vw,1.5rem)] md:text-[clamp(0.8em,6vw,2.5rem)] lg:text-[clamp(0.8em,6vw,3.5em)]
        xl:text-[clamp(0.8em,6vw,4rem)]"
        >
          <a href="mailto:charles@charismaticconsultingandservices.com">
            charles@charismaticconsultingandservices.com
          </a>
        </p>
        <div className="flex flex-col lg:flex-row gap-8 w-full py-4 bg-gray-50 justify-between items-center">
          <Logo to="/">CHARLES BELL</Logo>
          <div className="gap-3 flex flex-wrap justify-center items-center">
            {navLinks.map((link, index) => (
              <div
                key={index}
                className="p-2 rounded justify-center gap-2 flex cursor-pointer text-[#0e0e0e] hover:bg-[#e6f1ff] hover:text-[#0075FF] transition-all duration-300"
                onClick={() => scrollToSection(link.ref)}
              >
                <div className="text-base font-normal font-primary leading-5">
                  {link.label}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="w-full py-4 bg-gray-50 justify-between items-center">
          <div className="p-2 rounded justify-center items-start gap-2 flex">
            <img
              src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Frame-0b2b7776-f9b2-43f3-9131-024da3c84629.svg"
              alt="Frame"
            />
            <div className="text-[#0e0e0e] text-base font-normal font-primary leading-5">
              2025 Charismatic Consulting &amp; Services. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
